import Parse from "parse";

export interface AudioDonationAttributes {
  id: string;
  objectId: string;
  createdAt: Date;
  updatedAt: Date;
  audio?: Parse.File | undefined;
  confirmedDataset?: boolean | undefined;
  confirmedGame?: boolean | undefined;
  confirmedRights?: boolean | undefined;
  dataset: boolean;
  game: boolean;
  language?: string | undefined;
  microphoneType?: string | undefined;
  recordingEnvironment?: string | undefined;
  speakerAge?: number | undefined;
  spokenText?: string | undefined;
  synthetic?: boolean | undefined;
  voiceGender?: string | undefined;
}

export class AudioDonation extends Parse.Object<AudioDonationAttributes> {
  static className: string = "Antiscam_AudioDonation";

  constructor(data?: Partial<AudioDonationAttributes>) {
    super("Antiscam_AudioDonation", data as AudioDonationAttributes);
  }

  get audio(): Parse.File | undefined {
    return super.get("audio");
  }
  set audio(value: Parse.File | undefined) {
    super.set("audio", value);
  }

  get confirmedDataset(): boolean | undefined {
    return super.get("confirmedDataset");
  }
  set confirmedDataset(value: boolean | undefined) {
    super.set("confirmedDataset", value);
  }

  get confirmedGame(): boolean | undefined {
    return super.get("confirmedGame");
  }
  set confirmedGame(value: boolean | undefined) {
    super.set("confirmedGame", value);
  }

  get confirmedRights(): boolean | undefined {
    return super.get("confirmedRights");
  }
  set confirmedRights(value: boolean | undefined) {
    super.set("confirmedRights", value);
  }

  get dataset(): boolean {
    return super.get("dataset");
  }
  set dataset(value: boolean) {
    super.set("dataset", value);
  }

  get game(): boolean {
    return super.get("game");
  }
  set game(value: boolean) {
    super.set("game", value);
  }

  get language(): string | undefined {
    return super.get("language");
  }
  set language(value: string | undefined) {
    super.set("language", value);
  }

  get microphoneType(): string | undefined {
    return super.get("microphoneType");
  }
  set microphoneType(value: string | undefined) {
    super.set("microphoneType", value);
  }

  get recordingEnvironment(): string | undefined {
    return super.get("recordingEnvironment");
  }
  set recordingEnvironment(value: string | undefined) {
    super.set("recordingEnvironment", value);
  }

  get speakerAge(): number | undefined {
    return super.get("speakerAge");
  }
  set speakerAge(value: number | undefined) {
    super.set("speakerAge", value);
  }

  get spokenText(): string | undefined {
    return super.get("spokenText");
  }
  set spokenText(value: string | undefined) {
    super.set("spokenText", value);
  }

  get synthetic(): boolean | undefined {
    return super.get("synthetic");
  }
  set synthetic(value: boolean | undefined) {
    super.set("synthetic", value);
  }

  get voiceGender(): string | undefined {
    return super.get("voiceGender");
  }
  set voiceGender(value: string | undefined) {
    super.set("voiceGender", value);
  }
}

Parse.Object.registerSubclass("Antiscam_AudioDonation", AudioDonation);
